import { eventNames, useCoreEvents } from '@carvana/core-events';
import {
  useSetSebastianStatus,
  SebastianStatus
} from '~/context/vdp/SebastianContext';

const CHAT_UI_EVENT = 'header-chat-ui';

export default function useSebastianLoaded() {
  const setSebastianStatus = useSetSebastianStatus();

  useCoreEvents(eventNames.chatUi.ready, () => {
    // Wait a tick before updating the status. The stack trace is unclear on
    // where the issue lies, but it may be in the microfrontend package or
    // perhaps the ChatUI MFE. In any case, without this, an error appears in
    // the browser console:
    //
    // Warning: Cannot update a component (`SebastianContextProvider`) while
    // rendering a different component (`rg`).
    window.setTimeout(() => {
      setSebastianStatus(SebastianStatus.Ready);
    }, 0);
  });

  useCoreEvents(eventNames.mfer.events, event => {
    if (event.name === CHAT_UI_EVENT && event.error) {
      setSebastianStatus(SebastianStatus.Error);
    }
  });
}
